import routes from 'sitewide-js/core_pre_webpack/routes';
import * as ApiUtils from 'js/utils/api_utils';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';
import { BatchImpressionReporter } from 'js/utils/impressions/watchImpressions';

type ViewedNews = {
  userId: number;
  postId?: number | string;
  paperUpdateId?: number | string;
  workId?: number | string;
  openalexWorkId?: number | string;
  numCommentsOnView?: number;
  numReactionsOnView?: number;
};

const reportViews = (items: ViewedNews[]) => {
  ApiUtils.post(
    routes.api_v0_community_views_path({ subdomain_param: 'api' }),
    { views: items.map((props: ViewedNews) => toSnakecaseKeys(props)) },
  );
};

const batchViewUploader = new BatchImpressionReporter<ViewedNews>(reportViews);

export function createNewsView(
  props: ViewedNews,
): Promise<{ success: boolean }> {
  // Spammers get rate-limited "spoofed" posts with ID 0
  if (
    props.paperUpdateId ||
    props.postId ||
    props.workId ||
    props.openalexWorkId
  ) {
    batchViewUploader.registerView(props);
  }
  return new Promise((resolve) => resolve({ success: true }));
}
